<div class="flex flex-column justify-content-center align-items-center gap-4">
  <div class="flex text-center w-16rem">
    <p class="text-1xl font-bold">{{ message }}</p>
  </div>
  <div class="flex flex-row gap-4">
    <p-button class="secondary-button" label="Cancelar" (click)="closeDialog(false)" />
    <p-button class="primary-button" label="Aceptar" (click)="closeDialog(true)" />
  </div>
</div>
